
export default {
  methods: {
    $startLoading(div = null, background = null, text = null){
      this.$vs.loading({
        text: text || 'الرجاء الإنتظار',
        background: background,
        container: div,
        scale: 0.8
      })
    },
    $closeLoading(div = null){
      if(div) this.$vs.loading.close(div + ' > .con-vs-loading')
      else this.$vs.loading.close()
    }
  }
}

